import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import TimeSelect from "../../components/TimeSelect";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Heading,
  FormControl,
  FormLabel,
  Stack,
  Input,
  Button,
  Box,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Flex,
  useToast,
} from "@chakra-ui/react";
import { LuCopyPlus } from "react-icons/lu";
import Reports from "./editrequesttabs/Reports";
import Communication from "./editrequesttabs/Communication";

const API_BASE_URL = "https://qaapirgeneng.digitalfields.co.za/ws1.cfc";

const EditRequest = () => {
  const [request, setRequest] = useState([]);
  const [reqBookingDateTime, setReqBookingDateTime] = useState({
    bookingDate: "",
    bookingTime: "",
  });
  const [assessCompletedDateTime, setAssessCompletedDateTime] = useState({
    bookingDate: "",
    bookingTime: "",
  });
  const [feedbackDateTime, setFeedbackDateTime] = useState({
    bookingDate: "",
    bookingTime: "",
  });
  const [reqAssessments, setReqAssessments] = useState([]);

  const [loading, setLoading] = useState(true);
  const toast = useToast();
  // Parameters neccessary for making api requests
  const { id } = useParams();
  const HuserID = localStorage.getItem("HuserID");
  const UUID = localStorage.getItem("UUID");

  // Fetching header data for selected Request
  const fetchRequest = async () => {
    try {
      setLoading(true);
      let url = `${API_BASE_URL}?method=getRequestHeaders&huserID=${HuserID}&uuid=${UUID}&HrequestID=${id}`;

      const response = await fetch(url, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setRequest(data[0]);
    } catch (error) {
      console.error("Error fetching request:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetching assessments for selected Request:
  const fetchReqAssessments = async () => {
    try {
      setLoading(true);
      let url = `${API_BASE_URL}?method=getRequestAsses&huserID=${HuserID}&uuid=${UUID}&HrequestID=${id}`;

      const response = await fetch(url, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setReqAssessments(data);
    } catch (error) {
      console.error("Error fetching assessments:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequest();
    fetchReqAssessments();
  }, []);

  // Posting date/time data for request booking
  const postAssessBookingDateTime = async () => {
    try {
      return await fetch(
        `${API_BASE_URL}?method=addBookingDateTime&huserID=${HuserID}&uuid=${UUID}&HrequestID=${request.HrequestID}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(reqBookingDateTime),
          mode: "no-cors",
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      toast({
        title: "DateTime Booking Submitted!",
        description: "",
        status: "success",
        duration: 6000,
        isClosable: true,
      });
    }
  };

  // Posting date/time data for assessment completion
  const postAssessCompleteDateTime = async () => {
    try {
      return await fetch(
        `${API_BASE_URL}?method=addBookingCompleteDateTime&huserID=${HuserID}&uuid=${UUID}&HrequestID=${request.HrequestID}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(assessCompletedDateTime),
          mode: "no-cors",
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      toast({
        title: "Success!",
        description: "Assessment Completion DateTime Submitted",
        status: "success",
        duration: 6000,
        isClosable: true,
      });
    }
  };

  // Posting date/time data for feedback given
  const postFeedbackDateTime = async () => {
    try {
      return await fetch(
        `${API_BASE_URL}?method=addFeedbackGivenDateTime&huserID=${HuserID}&uuid=${UUID}&HrequestID=${request.HrequestID}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(feedbackDateTime),
          mode: "no-cors",
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      toast({
        title: "Feedback DateTime Booking Submitted!",
        description: "",
        status: "success",
        duration: 6000,
        isClosable: true,
      });
    }
  };

  // Updated function to post assessment link with new parameters
  const postAssessLink = async (supplierIndex, HsupplierID, HrequestID, externallink) => {
    try {
      return await fetch(
        `${API_BASE_URL}?method=addAssessmentLink&huserID=${HuserID}&uuid=${UUID}&HsupplierID=${HsupplierID}&HrequestID=${HrequestID}&URLLINK=${externallink}`,
        {
          method: "POST",
          mode: "no-cors",
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      toast({
        title: "Assessment Link Updated",
        description: "",
        status: "success",
        duration: 6000,
        isClosable: true,
      });
    }
  };

  const handleDateTimeChange = (e) => {
    const { name, value } = e.target;

    if (name === "bookingDate") {
      setReqBookingDateTime({
        ...reqBookingDateTime,
        bookingDate: value,
      });
    }
    if (name === "assessCompleteDate") {
      setAssessCompletedDateTime({
        ...assessCompletedDateTime,
        bookingDate: value,
      });
    }
    if (name === "feedbackDate") {
      setFeedbackDateTime({
        ...feedbackDateTime,
        bookingDate: value,
      });
    }
  };

  const handleLinkChange = (index, e) => {
    const { value, name } = e.target;
    const updatedAssessments = reqAssessments.map((assess, i) => {
      if (i === index) {
        return { ...assess, [name]: value };
      }
      return assess;
    });
    setReqAssessments(updatedAssessments);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name } = e.target;

    if (name === "bookDateTime") {
      postAssessBookingDateTime();
    }
    if (name === "assessCompleteDateTime") {
      postAssessCompleteDateTime();
    }
    if (name === "feedbackDateTime") {
      postFeedbackDateTime();
    }
    if (name === "updateAssess") {
      const targetAssess = e.target.getAttribute("data-key");

      postAssessLink(
        targetAssess,
        reqAssessments[targetAssess].allocHassessmentHrequestID
      );
    }
  };

  return (
    <Box p={8}>
      {/* Edit Request page heading */}
      <Heading className="text-xl font-bold mb-4" mb={5}>
        Edit Request
      </Heading>

      {/* Request Headers */}
      <Table variant="simple" mb={16}>
        <Thead>
          <Tr>
            <Th>Date Recorded</Th>
            <Th>Client Name</Th>
            <Th>Candidate Name</Th>
            <Th>Battery Name</Th>
            <Th>Operational Department</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td>{request.dateRecorded}</Td>
            <Td>{request.clientName}</Td>
            <Td>{request.candFname + " " + request.candSname}</Td>
            <Td>{request.batteryName}</Td>
            <Td>{request.tdepartment}</Td>
          </Tr>
        </Tbody>
        <Thead>
          <Tr>
            <Th>Purpose</Th>
            <Th>Current Position</Th>
            <Th>Position Applied For</Th>
            <Th>Employment Type</Th>
            <Th>Current Status</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td>{request.purpose}</Td>
            <Td>{request.currentPosition}</Td>
            <Td>{request.positionAppliedFor}</Td>
            <Td>{request.tpositionType}</Td>
            <Td>{request.statusText}</Td>
          </Tr>
        </Tbody>
      </Table>

      {/* Tabs for - Manage, Communication, Reports */}
      <Tabs size="md" variant="enclosed" colorScheme="orange">
        <TabList>
          <Tab>Manage</Tab>
          <Tab>Communication</Tab>
          <Tab>Reports</Tab>
        </TabList>
        <TabPanels>
          {/* Manage Tab */}
          <TabPanel>
            <Flex
              direction="row"
              gap="4"
              bg="white"
              shadow="md"
              rounded="md"
              px="6"
              width="100%"
            >
              {/* Booking Form */}
              <Box flex="1">
                <form onSubmit={handleSubmit} name="bookDateTime">
                  {/* Booking date and time picker */}
                  <FormControl px="4">
                    <FormLabel fontWeight="bold" my="6">
                      Assessment Participation
                    </FormLabel>
                    <Stack direction="column">
                      <Input
                        type="date"
                        name="bookingDate"
                        value={reqBookingDateTime.bookingDate}
                        onChange={handleDateTimeChange}
                        isRequired
                      />
                      <TimeSelect
                        name="bookingTime"
                        value={reqBookingDateTime.bookingTime}
                        onTimeChange={(timeValue) => {
                          setReqBookingDateTime((prev) => ({
                            ...prev,
                            bookingTime: timeValue,
                          }));
                        }}
                        isRequired
                      />
                    </Stack>

                    {/* DateTime Form submit button */}
                    <Button type="submit" my="6">
                      Submit
                    </Button>
                  </FormControl>
                </form>
              </Box>
              <Box flex="1">
                {/* Assessment Completion Form */}
                <form onSubmit={handleSubmit} name="assessCompleteDateTime">
                  {/* Assessment Completion date and time picker */}
                  <FormControl px="4">
                    <FormLabel fontWeight="bold" my="6">
                      Assessment Completion
                    </FormLabel>
                    <Stack direction="column">
                      <Input
                        type="date"
                        name="assessCompleteDate"
                        value={assessCompletedDateTime.bookingDate}
                        onChange={handleDateTimeChange}
                        isRequired
                      />
                      <TimeSelect
                        name="assessCompleteTime"
                        value={assessCompletedDateTime.bookingTime}
                        onTimeChange={(timeValue) => {
                          setAssessCompletedDateTime((prev) => ({
                            ...prev,
                            bookingTime: timeValue,
                          }));
                        }}
                        isRequired
                      />
                    </Stack>

                    {/* DateTime Form submit button */}
                    <Button type="submit" my="6">
                      Submit
                    </Button>
                  </FormControl>
                </form>
              </Box>
              <Box flex="1">
                {/* Feedback Form */}
                <form onSubmit={handleSubmit} name="feedbackDateTime">
                  {/* Feedback date and time picker */}
                  <FormControl px="4">
                    <FormLabel fontWeight="bold" my="6">
                      Feedback Given
                    </FormLabel>
                    <Stack direction="column">
                      <Input
                        type="date"
                        name="feedbackDate"
                        value={feedbackDateTime.bookingDate}
                        onChange={handleDateTimeChange}
                        isRequired
                      />
                      <TimeSelect
                        name="feedbackTime"
                        value={feedbackDateTime.bookingTime}
                        onTimeChange={(timeValue) => {
                          setFeedbackDateTime((prev) => ({
                            ...prev,
                            bookingTime: timeValue,
                          }));
                        }}
                        isRequired
                      />
                    </Stack>

                    {/* DateTime Form submit button */}
                    <Button type="submit" my="6">
                      Submit
                    </Button>
                  </FormControl>
                </form>
              </Box>
            </Flex>

            {/* Cancel Button - Bottom Right */}
            <Flex justifyContent="flex-end" mt={4} mb={6}>
              <Button 
                colorScheme="red" 
                size="md"
                isDisabled={
                  !(
                    // Condition 1: statusText is 'Recorded'
                    request?.statusText === 'Recorded' ||
                    // Condition 2: statusText is anything else AND cancellactiverequestyn = 1
                    (request?.statusText !== 'Recorded' && 
                     localStorage.getItem("cancellactiverequestyn") === "1")
                  )
                }
                onClick={async () => {
                  if (
                    request?.statusText === 'Recorded' ||
                    (request?.statusText !== 'Recorded' && 
                     localStorage.getItem("cancellactiverequestyn") === "1")
                  ) {
                    try {
                      await fetch(
                        `${API_BASE_URL}?method=cancellRequest&huserID=${HuserID}&uuid=${UUID}&HrequestID=${id}`,
                        {
                          method: "POST",
                          mode: "no-cors",
                        }
                      );
                      
                      toast({
                        title: "Request Cancelled",
                        description: "",
                        status: "success",
                        duration: 6000,
                        isClosable: true,
                      });
                      
                      // Refresh the Manage tab data
                      await fetchRequest();
                      await fetchReqAssessments();
                    } catch (error) {
                      console.log(error);
                    }
                  }
                }}
              >
                Cancel
              </Button>
            </Flex>

            {/* Assessment List grouped by supplier */}
            <div
              className="assessment-list"
              style={{
                width: "100%",
                marginBottom: "2rem",
                border: "2px solid #E2E8F0",
                borderRadius: "0.375rem",
                padding: "1rem",
                overflow: "scroll",
              }}
            >
              {reqAssessments.map((supplier, supplierIndex) => (
                <div key={`supplier-${supplierIndex}`} style={{ marginBottom: "2rem" }}>
                  {/* Supplier header with input for external link */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      background: "#ebf8ff",
                      padding: "0.5rem",
                      borderRadius: "0.25rem",
                    }}
                  >
                    <div style={{ width: "25%", fontWeight: "bold" }}>
                      {supplier.supplier}
                    </div>
                    <div style={{ width: "55%" }}>
                      <input
                        type="url"
                        name="externallink"
                        placeholder="Supplier assessment link"
                        value={supplier.externallink || ""}
                        onChange={e => {
                          const updated = [...reqAssessments];
                          updated[supplierIndex].externallink = e.target.value;
                          setReqAssessments(updated);
                        }}
                        style={{
                          width: "100%",
                          padding: "0.25rem",
                          border: "1px solid #cbd5e0",
                          borderRadius: "0.25rem",
                        }}
                      />
                    </div>
                    <div style={{ width: "20%" }}>
                      <button
                        type="button"
                        onClick={() => {
                          postAssessLink(
                            supplierIndex,
                            supplier.HsupplierID,
                            request.HrequestID,
                            supplier.externallink
                          );
                        }}
                        style={{
                          padding: "0.25rem 0.75rem",
                          backgroundColor: "#718096",
                          color: "white",
                          border: "none",
                          borderRadius: "0.375rem",
                          cursor: "pointer",
                          fontSize: "0.875rem",
                        }}
                      >
                        Save Link
                      </button>
                    </div>
                  </div>
                  
                  {/* Assessment table header */}
                  <div style={{ display: "flex", marginTop: "0.5rem", fontWeight: "bold" }}>
                    <div style={{ width: "20%" }}>Assessment Name</div>
                    <div style={{ width: "20%" }}>Assessment Status</div>
                    <div style={{ width: "20%" }}>Booking Date/Time</div>
                    <div style={{ width: "20%" }}>Result Date</div>
                    <div style={{ width: "20%" }}>Assessment ID</div>
                  </div>
                  
                  {/* Assessments under this supplier */}
                  {supplier.assessmentList && supplier.assessmentList.DATA && 
                    supplier.assessmentList.DATA.map((assessment, assessmentIndex) => {
                      // Map the data array to column names
                      const assessmentData = {
                        HASSESSMENTID: assessment[0],
                        ASSESSMENTNAME: assessment[1],
                        BOOKINGDATETIME: assessment[2],
                        RESULTDATE: assessment[3],
                        ASSESSMENTSTATUS: assessment[4],
                        ALLOCHASSESSMENTHREQUESTID: assessment[5]
                      };
                      
                      return (
                        <div
                          key={`assessment-${supplierIndex}-${assessmentIndex}`}
                          style={{
                            display: "flex",
                            marginLeft: "2rem",
                            borderBottom: "1px solid #e2e8f0",
                            padding: "0.25rem 0",
                          }}
                        >
                          <div style={{ width: "20%" }}>{assessmentData.ASSESSMENTNAME}</div>
                          <div style={{ width: "20%" }}>{assessmentData.ASSESSMENTSTATUS}</div>
                          <div style={{ width: "20%" }}>{assessmentData.BOOKINGDATETIME}</div>
                          <div style={{ width: "20%" }}>{assessmentData.RESULTDATE || "N/A"}</div>
                          <div style={{ width: "20%" }}>{assessmentData.HASSESSMENTID}</div>
                        </div>
                      );
                    })}
                </div>
              ))}
            </div>
          </TabPanel>

          {/* Communication Tab */}
          <TabPanel>
            <Communication recipientID={request.candidateID} HrequestID={id} />
          </TabPanel>

          {/* Reports Tab */}
          <TabPanel>
            <Reports HrequestID={id} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default EditRequest;
